<template>

  <div class="box-signup">
    <div class="container">
      <div class="legend text--white">
          <h2>En este momento no podemos realizar esta operación</h2>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'SignUp',
  metaInfo () {
    return {
      title: 'Crea tu cuenta | Cumplo'
    }
  }
}
</script>

<style scoped lang="scss">

.box-signup {
  padding: 5rem 0;
  min-height: 450px;
  background: rgb(60,186,104);
  background: linear-gradient(180deg, rgba(60,186,104,1) 5%, rgba(11,171,100,1) 30%, rgba(53,87,76,1) 63%);

}
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

.legend {
  margin: 0;
  margin-top: 70px;
  font-size: 1.3em;
}
@media (max-width: 760px) {

  .legend {
  margin: 0;
  font-size: 1.3em;
  }
  .container {
    flex-direction: column-reverse;
  }
}

@media (min-width: 1023px) {
  .container {
    width: 100%;
    flex-direction: row-reverse;
  }

  .legend {
    margin-right: 2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/SignUp.vue